import { useState } from 'react';
import styled from 'styled-components';

import Jumbotron from 'components/shared/ai/Jumbotron';
import AISparkleIcon from 'svg/AISparkleIcon';

type HeaderProps = {
  isExpanded?: boolean;
  setIsExpanded?: (isExpanded: boolean) => void;
} & React.PropsWithChildren;

function Header({ isExpanded, setIsExpanded, children }: HeaderProps) {
  const shouldShowShowHideButton = setIsExpanded !== undefined;
  return (
    <HeaderContainer>
      <TitleContainer>
        <AISparkleIcon width={14} height={14} />
        <HeaderText>{children}</HeaderText>
      </TitleContainer>
      {shouldShowShowHideButton && (
        <ShowHideButton onClick={() => setIsExpanded(!isExpanded)}>{isExpanded ? 'Hide' : 'Show'}</ShowHideButton>
      )}
    </HeaderContainer>
  );
}

type BannerProps = {
  title: string;
  hasBeenCollapsed?: boolean;
  onCollapseHeader?: () => void;
} & React.PropsWithChildren;

export default function Banner({ children, title, hasBeenCollapsed = false, onCollapseHeader }: BannerProps) {
  const [isExpanded, setIsExpanded] = useState(!hasBeenCollapsed);

  const handleSetIsExpanded = (value: boolean) => {
    setIsExpanded(value);

    if (!value && !hasBeenCollapsed) {
      onCollapseHeader?.();
    }
  };

  return (
    <Jumbotron style={{ alignItems: 'flex-start', overflow: 'auto' }}>
      <Header isExpanded={isExpanded} setIsExpanded={handleSetIsExpanded}>
        {title}
      </Header>
      {isExpanded && <ContentContainer>{children}</ContentContainer>}
    </Jumbotron>
  );
}

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 24px;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const HeaderText = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.2px;

  color: #5e42e1;
`;

const ShowHideButton = styled.button`
  all: unset;
  cursor: pointer;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  text-align: right;
  letter-spacing: 0.2px;
  text-decoration-line: underline;

  color: #5e42e1;
`;

const ContentContainer = styled.div`
  padding: 0 24px 24px 24px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.2px;
  white-space: pre;
  text-wrap: wrap;

  ul {
    padding-left: 20px;
  }
`;
